import mikeSharedTheme from '../../shared/styles/mikeSharedTheme';

export const CARD_SPACING = mikeSharedTheme.spacing(2);
export const CARD_HEIGHT = 300;
export const CARD_WIDTH = 320;
export const CARD_MEDIA_HEIGHT = 178;
